import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from '../Category/ProductItem';
import Pagination from '../../hocs/Pagination/Pagination';
import { unique, intersect } from '../../utils/array';
import { translate } from '../../utils/locale';
import s from './SearchResults.scss';

const SearchResults = ({ setup, searchInputText, location, productCache }) => {
	if (!productCache || !productCache[setup.market] || !productCache[setup.market][setup.pricelist]) return null;

	const filtering = productCache[setup.market][setup.pricelist];
	const searchTerms = filtering.searchTerms[setup.language];
	let productList = [];

	if (searchInputText && searchInputText !== '') {
		searchInputText.split(' ').forEach((wordPart, i) => {
			if (wordPart === '') return;
			let currentSearchMatch = [];

			Object.keys(searchTerms).forEach((term) => {
				const wordPartIndex = term.toLowerCase().indexOf(wordPart.toLowerCase());
				let specificity = 1;

				if (wordPartIndex !== -1) {
					specificity = 1 / searchTerms[term].length; // More products per key = less specific
					specificity = specificity * 100 * (wordPartIndex === 0 ? 10 : 1);

					currentSearchMatch.push({ term, specificity, products: searchTerms[term] });
				}
			});

			if (currentSearchMatch.length === 0) return;

			currentSearchMatch.sort((a, b) => {
				if (a.specificity === b.specificity) return 0;
				return a.specificity - b.specificity < 0 ? 1 : -1;
			});
			currentSearchMatch = currentSearchMatch.reduce((acc, product) => [...acc, ...product.products], []);
			currentSearchMatch = unique(currentSearchMatch);

			productList = i === 0 ? [...currentSearchMatch] : intersect(productList, currentSearchMatch);
		});
	}

	if (!searchInputText || location.type !== 'SEARCH') return null;

	return (
		<div className={s.searchResults}>
			<Pagination variantClasses={['pagination__search', 'productItem__perRow_4']} ListComponent={ProductItem} list={productList} cache={filtering.products} currentPath="search" currentView="Search" canonical />
		</div>
	);
};

const mapState = ({ environment, productCache, location }) => ({
	setup: environment.setup,
	searchInputText: environment.searchInputText,
	location,
	productCache,
});

export default hot(module)(connect(mapState)(SearchResults));
